import React from 'react'; // Bibliotecas
import './VerticalExpander.css'; // CSS

class VerticalExpander extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            height: 0
        };

        this.node = React.createRef();
    }

    calcHeight = () => {
        const childrens = this.node.current.children;
        let height = 0;

        for(let i=0; i<childrens.length; i++)
            height += childrens[i].offsetHeight;

        return height;
    }
    
    componentDidMount(){
        this.setState({
            height: this.calcHeight()
        });
    }
    
    render(){
        const height = this.state.height;
        const expand = this.props.expand;
        const style = {height: expand? height : 0};
        
        return (
            <div className="vertical-expander" style={style} ref={this.node}>
                {this.props.children}
            </div>
        );
    }
}

export default VerticalExpander;